export default "__VITE_ASSET__mU$1OZ$4__"